import { render, staticRenderFns } from "./ProdctSizeAndStyle.vue?vue&type=template&id=474dd95f&"
import script from "./ProdctSizeAndStyle.vue?vue&type=script&lang=js&"
export * from "./ProdctSizeAndStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports